import React from "react";
import "./../styles/mdoCountCard.scss";
import PropTypes from "prop-types";

// import moment from "moment"
import { format } from "date-fns";
import Chart from "react-apexcharts";

import useSWR from "swr";

import { query_generate } from "../../../utilities/_query_generate";

import LoadingCard from "./loadingCard";

import mdo_count_img from "./../../../img/dashboard_card/MDO_count.svg";

const fakeData = {
  attendance_data: {
    total_count: 336,
    assigned_count: 0,
    attendance_count: 60,
    percentage: 0,
  },
  call_data: {
    call_count: 1157,
    call_per_mdo: 19.28,
  },
};

const mdo_count = {
  card_heading: "MDO Count",
  state: "mdo_count_state",
  api_link: `/api/reports/v3/mdo-performance-report`,
  conrner_right_top_img: mdo_count_img,
};

const options = {
  chart: {
    height: 320,
    type: "radialBar",
  },
  colors: ["#f5beb4"],
  plotOptions: {
    radialBar: {
      startAngle: -135,
      endAngle: 135,
      hollow: {
        size: "79%",
      },

      track: {
        background: "#F9EBF1",
        startAngle: -135,
        endAngle: 135,
      },
      dataLabels: {
        name: {
          show: true,
          label: "Targets Achieved",
          fontSize: "12px",
          color: "#707070",
          fontFamily: "Roboto', sans-serif",
          fontWeight: 300,
        },
        value: {
          fontFamily: "Roboto', sans-serif",
          fontSize: "24px",
          fontWeight: 500,
          color: "#434364",
        },
      },
    },
  },
  fill: {
    type: "gradient",
    gradient: {
      shade: "dark",
      type: "horizontal",
      gradientToColors: ["#e2136e"],
      stops: [0, 100],
    },
  },
  stroke: {
    lineCap: "round",
  },
  labels: ["Daily target achieved"],
};

/**
 * @description Newly designed MDO count card showing active MDOs, assigned MDOs, active MDO number
 * and gains or losses from last week.
 * @component MDO Count Card 2
 * @category Dashboard
 * @author Zoha
 */
const MDOCountCard2 = (props) => {
  let query_pre_process = [
    {
      key: "team",
      values:
        props.filterElement.relational !== undefined
          ? props.filterElement.relational.team
          : [],
    },
    {
      key: "region",
      values:
        props.filterElement.relational !== undefined
          ? props.filterElement.relational.region
          : [],
    },
    {
      key: "area",
      values:
        props.filterElement.relational !== undefined
          ? props.filterElement.relational.area
          : [],
    },
    {
      key: "territory",
      values:
        props.filterElement.relational !== undefined
          ? props.filterElement.relational.territory
          : [],
    },
    {
      key: "agency",
      values:
        props.filterElement.relational !== undefined
          ? props.filterElement.relational.agency
          : [],
    },
  ];
  let query = query_generate(query_pre_process);

  const url = `${process.env.REACT_APP_API_URL}/${mdo_count["api_link"]}?date=${
    //moment(props.date).format("yyyy-MM-dd")
    format(new Date(props.date), "yyyy-MM-dd")
  }${query !== "" ? "&" + query : ""}`;

  const { data: mdo_count_state } = useSWR(url);
  //const mdo_count_state = { ...fakeData };

  return (
    <div className="card-col col s12 m6 l6 " style={{ width: "100%" }}>
      {!mdo_count_state ? (
        <LoadingCard card_heading={`${mdo_count.card_heading}`} />
      ) : (
        <div
          className="card data-cardx"
          style={{
            background: "transparent",
            border: "none",
            zIndex: 2,
            paddingTop: 0,
          }}
        >
          <div
            className="rad-chart"
            style={{ flexDirection: "column", alignItems: "center" }}
          >
            <div className="attendance-container-small">
              <h2>Attendance count</h2>
              <p>{mdo_count_state["attendance_data"].attendance_count}</p>
            </div>
            <Chart
              options={options}
              series={[
                Math.round(
                  (mdo_count_state["call_data"].call_per_mdo / 35) * 100
                ),
              ]}
              type="radialBar"
              height={300}
            />
          </div>

          {mdo_count_state && (
            <div className="card-body">
              {/* <div className="card-graph">
                <Chart
                  options={options}
                  series={[
                    100,
                    Math.round(
                      (mdo_count_state.current.assigned_count /
                        mdo_count_state.current.total_count) *
                        100
                    ),
                    mdo_count_state.current.total_count !== 0
                      ? Math.round(
                          (mdo_count_state.current.attendance_count /
                            mdo_count_state.current.assigned_count) *
                            100
                        )
                      : 0,
                  ]}
                  type="radialBar"
                  height={320}
                />
              </div> */}

              <div className="card-content-container">
                <div className="row1">
                  <div className="registered">
                    <div className="value">
                      {mdo_count_state["attendance_data"].total_count}
                    </div>
                    <div className="tag">Registered</div>
                  </div>

                  <div className="assigned">
                    <div className="value">
                      {mdo_count_state["attendance_data"].assigned_count}
                    </div>
                    <div className="tag">Assigned for the day</div>
                  </div>
                </div>

                <div className="row2">
                  <div className="active-today">
                    <div className="value">
                      {mdo_count_state["call_data"].call_count}
                    </div>
                    <div className="tag">Total calls </div>
                  </div>

                  <div className="active-today">
                    <div className="value">
                      {mdo_count_state["call_data"].call_per_mdo}
                    </div>
                    <div className="tag">Total call per MDO</div>
                  </div>

                  {/* <div className="comparison">
                    <div
                      className={`value ${
                        mdo_count_state.deltas.with_last_week >= 0
                          ? `positive`
                          : `negative`
                      }`}
                    >
                      {mdo_count_state.deltas.with_last_week >= 0 ? `+` : ``}
                      {mdo_count_state.deltas.with_last_week}%
                    </div>
                    <div className={`tag`}>From Last Week</div>
                  </div> */}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MDOCountCard2;

MDOCountCard2.propTypes = {
  /**
   * Current date to send fetch request for data on that particular date
   */
  date: PropTypes.instanceOf(Date).isRequired,
  /**
   * Object of filters selected from the Filter Element component to send fetch request accordingly
   */
  filterElement: PropTypes.object.isRequired,
};
